import { paisService } from '@/services';

export const paisModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
  }),
  mutations: {
    load(state) {
      paisService.getPaises()
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });    
    },
  }
}